import { UniformLink } from "../src/link.tsx";
export type { LinkProps } from "../../../../libraries/design/components/link/src/link.tsx";

export default UniformLink;
